import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'rebass';
import { Button } from 'semantic-ui-react';
import { Form, Dropdown, Input } from 'formsy-semantic-ui-react';

import { Text } from '../Base';
import { COLOR, FONT_SIZE, SPACE } from '../Theme';
import MockExamDataCard from '../MockExamDataCard';
import { MAJOR_OPTIONS } from '../../Components/AddPersonalInformation/AddPersonalInformation';

const SInput = styled(Input)`
  &.disabled.field,
  div.ui.disabled.input {
    opacity: 1 !important;
  }
  .ui.input input:disabled {
    border-color: ${COLOR.greyscale.grey5};
    background: ${COLOR.greyscale.grey5};
  }
  .ui input {
    width: 100%;
  }
`;
const StyleFormField = styled(Form.Field)`
  width: 100%;
`;
const StyleDropdown = styled(Dropdown)`
  &.disabled.field,
  div.ui.disabled.input {
    opacity: 1 !important;
  }
  .ui.disabled.dropdown {
    border-color: ${COLOR.greyscale.grey5};
    background: ${COLOR.greyscale.grey5};
    opacity: 1;
  }
`;

const FormBox = styled(Box)`
  max-width: 520px;
`;

const ErrorText = styled(Text)`
  position: absolute;
  top: 0px;
`;

const FieldInputData = ({ label, name = 'none', disabled, defaultValue, options }) => {
  return (
    <Flex mt={SPACE.xsmall} alignItems="center">
      <Flex width={4 / 11} pt={SPACE.small} justifyContent="flex-end">
        <Text fontWeight="500" fontSize={FONT_SIZE.normal}>
          {label}
        </Text>
      </Flex>
      <Flex width={1 / 11} />
      <Flex width={6 / 11} pt={SPACE.small} justifyContent="flex-start">
        <StyleFormField>
          {options ? (
            <StyleDropdown
              name={name}
              selection
              defaultValue={defaultValue}
              disabled={disabled}
              options={options}
              fluid
            />
          ) : (
            <SInput name={name} disabled={disabled} defaultValue={defaultValue} />
          )}
        </StyleFormField>
      </Flex>
    </Flex>
  );
};

const renderData = (profile, error) => {
  const options = [
    { text: 'SCIENCE', value: 'SCIENCE' },
    { text: 'SOCIAL', value: 'SOCIAL' },
    { text: 'ENGLIST', value: 'ENGLIST' },
  ];
  profile.program = 2;
  return (
    <Fragment>
      <FormBox>
        <Flex alignItems="center">
          <Flex width={1 / 3} pt={SPACE.small} />
          <Flex width={2 / 3} pt={SPACE.small} justifyContent="flex-start">
            <ErrorText fontSize={FONT_SIZE.small} fontWeight={300} color={COLOR.primary}>
              {error}
            </ErrorText>
          </Flex>
        </Flex>
        <FieldInputData
          name="universityName"
          label="โรงเรียน"
          disabled
          defaultValue={profile.locationName || ''}
        />
        <FieldInputData
          name="firstname"
          label="ชื่อ"
          disabled
          defaultValue={profile.firstName || ''}
        />
        <FieldInputData
          name="lastname"
          label="นามสกุล"
          disabled
          defaultValue={profile.lastName || ''}
        />
        <FieldInputData
          name="major"
          disabled
          options={MAJOR_OPTIONS}
          label="แผนการเรียน"
          defaultValue={profile.major || ''}
        />
        <FieldInputData
          disabled
          name="studentNumber"
          label="รหัสนักเรียน"
          defaultValue={profile.studentCode || ''}
        />
        <FieldInputData name="ssid" label="เลขบัตรประชาชน" defaultValue={profile.ssid || ''} />
        <FieldInputData name="phone" label="เบอร์โทรศัพท์" defaultValue={profile.phone || ''} />
        <FieldInputData name="email" label="อีเมล" defaultValue={profile.email || ''} />
        <Flex mt={SPACE.large} justifyContent="center">
          <Button type="submit" basic primary circular style={{ width: '197px' }}>
            อัพเดตข้อมูล
          </Button>
        </Flex>
      </FormBox>
    </Fragment>
  );
};

const EditDataForm = ({ profile, error = '', onSubmit }) => {
  const submit = form => {
    const { ssid, phone, email } = form;
    onSubmit({ ssid, phone, email });
  };

  return (
    <MockExamDataCard headText="ข้อมูลของน้อง">
      <Form onValidSubmit={submit}>
        <Flex p={SPACE.small} justifyContent="center">
          {renderData(profile, error)}
        </Flex>
      </Form>
    </MockExamDataCard>
  );
};

export default EditDataForm;
